// extracted by mini-css-extract-plugin
export var active = "navlinksResponsive-module--active--f2WWA";
export var links = "navlinksResponsive-module--links--0JTL6";
export var linksList = "navlinksResponsive-module--linksList--YTB1H";
export var menuGrid = "navlinksResponsive-module--menuGrid--CvYg8";
export var wrapper = "navlinksResponsive-module--wrapper--T4LfE";